export default __webpack_public_path__ + "static/info_traffic_block_picto-e55d505eb85c545e5ec83a197d7c1a89.svg";